/*
 * Important note:
 * This package get inlined into HTML via a HTMLRewriter in a CF-Worker.
 * The procedure utilizes function.toString() which requires the code to be 100%
 * self-contained. Be careful when modifying this package and test, test, test...
 */
export default ({ cookie = [], local = [], session = [], release = true } = {}) => {
    const classes = document.documentElement.classList;
    const exclude = {
        cookie: [
            ...new Set(
                [
                    "session",
                    "frontend",
                    "uuid",
                    "experiment",
                    "gibmirndonut",
                    "preview",
                    "api_token",
                    "e2e_debug",
                    "@apfelkiste.internal",
                    "@schema/webpageelement.cookiebanner",
                    // dynamicyield (homer)
                    "dy",
                    // dynamicyield (native)
                    "_dyid",
                    "_dyid_server",
                    "_dyjsession",
                    "_dy_soct",
                    "dy_fs_page",
                    "_dy_cs_storage_items",
                    "_dy_cs_cookie_items",
                    // GA4 / gtag
                    "_ga",
                    "_ga_*",
                    "_gcl_au",
                    "_gcl_aw",
                    "_gid",
                ].concat(cookie),
            ),
        ],
        localStorage: [
            ...new Set(
                [
                    "[@homer.core/session]",
                    "[@homer.core/attribution]",
                    "[@homer.core/entry]",
                    "[@apfelkiste/sink]", // replaces the previous item
                    // dynamicyield (native)
                    "_dyuss_",
                    "_dyaud_sess",
                    "_dy_tsrc",
                    "_dyaud_nchc",
                    "_dyaud_page",
                    "_dy_device",
                    "_dycst",
                    "_dy_csc",
                    "dyexps",
                    "dy_att_exps",
                    "_dyrc",
                    "_dybatch",
                    "_dy_cs_session_items",
                    "_dy_cs_local_items",
                    // GA4 / gtag
                    "_user_id",
                    "_gcl_ls",
                ].concat(local),
            ),
        ],
        sessionStorage: [
            ...new Set(
                [
                    "[@homer.core/email]",
                    "[@homer.core/phone]",
                    "[@homer.core/attribution]",
                    // GA4 / gtag
                    "_user_id",
                    "_gcl_ls",
                ].concat(session),
            ),
        ],
    };
    const serviceWorker = "serviceWorker" in navigator && navigator.serviceWorker;
    const localStorage = (function () {
        try {
            return "localStorage" in globalThis && globalThis.localStorage.getItem && globalThis.localStorage;
        } catch (_) {}

        return false;
    })();
    const sessionStorage = (function () {
        try {
            return "sessionStorage" in globalThis && globalThis.sessionStorage.getItem && globalThis.sessionStorage;
        } catch (_) {}

        return false;
    })();

    return Promise.resolve(
        (() => {
            if (serviceWorker) {
                try {
                    return serviceWorker
                        .getRegistrations()
                        .then((registrations) => {
                            return Promise.allSettled(registrations.map((registration) => registration.unregister()));
                        })
                        .catch((error) => {
                            // purposely ignore
                        });
                } catch (error) {
                    // purposely ignore
                }
            }
        })(),
    )
        .then(() => {
            try {
                classes.add("isResetting");
            } catch (error) {
                // purposely ignore
            }
        })
        .then(() => {
            try {
                const excludeFull = (exclude.cookie || []).filter((name) => !name.endsWith("*"));
                const excludePrefix = (exclude.cookie || [])
                    .filter((name) => name.endsWith("*"))
                    .map((name) => name.slice(0, -1));
                const cookies = document.cookie.split(";");

                for (let i = 0; i < cookies.length; i++) {
                    const cookie = cookies[i];
                    const index = cookie.indexOf("=");
                    const name = (index > -1 ? cookie.substring(0, index) : cookie).trim();

                    if (excludeFull.indexOf(name) === -1 && excludePrefix.some((prefix) => name.startsWith(prefix)) === false) {
                        document.cookie = name + "=null;expires=Thu, 01 Jan 1970 00:00:00 UTC";
                    }
                }
            } catch (error) {
                // purposely ignore
            }
        })
        .then(() => {
            if (localStorage) {
                try {
                    const excludes = exclude.localStorage || [];

                    Object.keys(localStorage)
                        .filter((key) => {
                            for (let i = 0; i < excludes.length; i++) {
                                if (key.indexOf(excludes[i]) === 0) {
                                    return false;
                                }
                            }

                            return true;
                        })
                        .forEach((key) => {
                            try {
                                localStorage.removeItem(key);
                            } catch (error) {
                                // purposely ignore
                            }
                        });
                } catch (error) {
                    // purposely ignore
                }
            }
        })
        .then(() => {
            if (sessionStorage) {
                try {
                    const excludes = exclude.sessionStorage || [];

                    Object.keys(sessionStorage)
                        .filter((key) => {
                            for (let i = 0; i < excludes.length; i++) {
                                if (key.indexOf(excludes[i]) === 0) {
                                    return false;
                                }
                            }

                            return true;
                        })
                        .forEach((key) => {
                            try {
                                sessionStorage.removeItem(key);
                            } catch (error) {
                                // purposely ignore
                            }
                        });
                } catch (error) {
                    // purposely ignore
                }
            }
        })
        .finally(() => {
            try {
                if (release) {
                    classes.remove("isResetting");
                }
            } catch (error) {
                // purposely ignore
            }
        });
};
